export const LOCAL_STORAGE_KEYS = {
  subdomain: '@subdomain',
};
